<template>
  <div class="filter" ref='pfilter' :id="'filter_task'">
      <v-btn style="margin-top: 0; margin-bottom: 0" outline :disabled="disabled" :loading="!filterItensLoaded" @click="openTaskFilter()" color="primary">Filtro</v-btn>
    <p-filter-task-fields ref="pFilterTaskFields" @save="save" :individualFilter="individualFilter"></p-filter-task-fields>
    
    <div v-show="!disabled" v-if="showChip">
      <span v-if="chips.length > 5 || showOneChip">
        <v-btn id="showChip" small text-color="primary" color="green" outline round @click="showMoreFilters = !showMoreFilters">
          <span>Mostrar filtros...</span>
        </v-btn>
        <v-tooltip :attach="'#showChip'" bottom v-model="showMoreFilters">
          <v-card>
            <v-flex xs12>
              <v-tooltip bottom>
                <v-btn flat icon align-end color="#000" slot="activator">
                  <v-icon>close</v-icon>
                </v-btn>
                <span>Fechar</span>
              </v-tooltip>
            </v-flex>
            <v-tooltip bottom v-for="(value, index) in chips" :key="index">
              <!-- // close, se o campo for desabilitado ou a opção notclose estiver ativa ou a props de desabilitar o filtro estriver ativa ou o usuário não tiver permissão, en~toa não aparece o close -->
              <v-chip
                slot="activator"
                @input="deleteChip(value.name)"
                text-color="primary"
                :close="!(value.disabled == true || value['not_close'] == true || disabled)"
                color="green"
                outline
              >{{value.title}}
              </v-chip>
              <span>{{value.values}}</span>
            </v-tooltip>
          </v-card>
        </v-tooltip>
      </span>
      <span v-else>
        <v-tooltip bottom v-for="(value, index) in chips" :key="index">
          <!-- // close, se o campo for desabilitado ou a opção notclose estiver ativa ou a props de desabilitar o filtro estriver ativa ou o usuário não tiver permissão, en~toa não aparece o close -->
          <v-chip
            slot="activator"
            @input="deleteChip(value.name)"
            text-color="primary"
            :close="!(value.disabled == true || value['not_close'] == true || disabled)"
            color="green"
            outline
          >{{value.title}}
          </v-chip>
          <span>{{value.values}}</span>
        </v-tooltip>
      </span>
    </div>
  </div>
</template>

<style scoped>
  .filter{
    display: flex;
    flex-wrap: wrap;
  }
</style>

<script>
  /* eslint-disable key-spacing, comma-spacing */
  import PFilterTaskFields from './../shared/PFilterTaskFields'

  export default {
    data: () => ({
      editedItem: {id:'', properties:{task_template_id:[],exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:[],end_period:'',created_by:[],sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true,room:''}},
      defaultItem: {id:'', properties:{task_template_id:[],exibitionType:null,id_text:'',team_id:[],user_id:[],category:[],client:[],status:[],end_period:'',created_by:[],sortBy:'created_at',descending:true,showTaskLevel:1,showFinalized:true,room:''}},
      chips: [],
      individualFilter: {},
      showMoreFilters: false,
      // showOneChip variavel usada para contrair os chips em apenas um
      showOneChip: false
    }),
    components: {PFilterTaskFields},
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      filterItensLoaded: {
        type: Boolean,
        default: true
      },
      showChip: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      this.$http.get(`api/get_individual_filter`).then(res => {
        this.individualFilter = res.body
        this.individualFilter['properties'] = JSON.parse(this.individualFilter['properties'])
        // modifica o individualFIlter para atualizar os valores como exibitionType e listar Concluidas
        // recarrega a consulta de tarefas para buscar os novos valores
        this.$emit('changeIndividualFilter', JSON.parse(JSON.stringify(this.individualFilter)))
        this.mountChips()
      }, err => {
        console.log(err)
        this.$store.commit('snackbar/change_values', {
          text: `Ocorreu um erro ao carregar o filtro individual!`,
          color: 'error',
          dialog: true
        })
      })
    },
    methods: {
      save (item = this.individualFilter) {
        this.$store.commit('loader/change_dialog', true)
        // verifica se já não é string pois as vezes já está em string e ao transformar em string novamente da erro
        if (typeof item['properties'] === 'object') item['properties'] = JSON.stringify(item['properties'])
        this.$http.put(`api/change_individual_filter/${this.individualFilter['id']}`, item).then(res => {
          this.individualFilter = res.body
          this.individualFilter['properties'] = JSON.parse(this.individualFilter['properties'])
          // modifica o individualFIlter para atualizar os valores das propriedades
          // recarrega a consulta de tarefas para buscar os novos valores
          this.$emit('changeIndividualFilter', JSON.parse(JSON.stringify(this.individualFilter)))
          this.editedItem = this.defaultItem
          this.mountChips()
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar o filtro individual!`,
            color: 'error',
            dialog: true
          })
        })
        // this.close()
      },
      saveSpecificProps (properties) {
        Object.assign(this.individualFilter['properties'], properties)
        this.save()
      },
      deleteChip (field) {
        // Pegas os valores do filtro individual
        this.editedItem = JSON.parse(JSON.stringify(this.individualFilter))
        // zera apenas o campo que deletado
        this.editedItem['properties'][field] = this.defaultItem['properties'][field]
        this.save(this.editedItem)
      },
      openTaskFilter () {
        this.$refs.pFilterTaskFields.openTaskFilter(this.individualFilter)
      },
      mountChips () {
        this.chips = []
        let properties = this.individualFilter['properties']
        this.$http.post('api/task_filter_chips', properties).then(res => {
          this.chips = res.body
          setTimeout(() => {
            this.showOneChip = document.getElementById('options_task').clientHeight > 50
          }, 500)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: `Ocorreu um erro ao carregar os registros, reporte o erro!`,
            color: 'error',
            dialog: true
          })
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/PFilterTask.vue